import { validateGuide, type LessonGuide } from '../../shared/guide';

/**
 * ガイドJSONを取得して検証する。共有API（/api/share/<id>/guide）と
 * 同梱サンプル（/examples/*.guide.json）のどちらも同じ経路で読む。
 * 見つからない・読めない・検証に落ちるときはnullを返し、呼び出し側は
 * 通常のビューアとして動き続ける。
 */
export async function fetchGuide(url: string): Promise<LessonGuide | null> {
  try {
    const response = await fetch(url);
    // 204 = ガイドの付いていない共有。エラーでも同様にnullで通常表示に戻る。
    if (response.status === 204 || !response.ok) {
      // ボディを読み残すとブラウザがリクエストを未完了のまま抱え続けるので、明示的に捨てる。
      await response.body?.cancel();
      return null;
    }
    const result = validateGuide(await response.json());
    if ('errors' in result) {
      console.warn('ガイドの内容に誤りがあるため、通常表示にします:', result.errors);
      return null;
    }
    return result.guide;
  } catch {
    return null;
  }
}
